module.exports = __webpack_public_path__ + "assets/HypotenuseAndLegDetailed.660a8d32c462bef7367fc30a9e6c50ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/HypotenuseAndLegDetailed.png
// module id = 523
// module chunks = 0